// extracted by mini-css-extract-plugin
module.exports = {"modal":"FrameworkModal_modal__fMDTg","flex":"FrameworkModal_flex__2y61D","modalTitle":"FrameworkModal_modalTitle__1mDwK"};